import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'

export const formFilter: {
    input?: InputBuildProps
    select?: SelectBuildProps
    layout?: any
}[] = [
        {
            input: {
                id: 'dataInicio',
                label: 'Data Inicial (Data Registro)',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'dataFim',
                label: 'Data Final',
                placeholder: 'dd/mm/aaaa',
                type: 'date'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroRegistroContrato',
                label: 'N° Registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'numeroContrato',
                label: 'N° Contrato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'chassi',
                label: 'N° Chassi'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'marcaModelo',
                label: 'Marca/Modelo do Veiculo'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'anoModelo',
                label: 'Ano do Modelo do Veiculo',
                maxLength: 4
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'especie',
                label: 'Especie do Veiculo',
                optionsType: 'especieVeiculo',
                required: false
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'tipoOperacao',
                label: 'Tipo de Gravame',
                optionsType: 'type'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'placa',
                label: 'N° Placa:',
                maskReplace: 'placa'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'renavam',
                label: 'Renavam:',
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'status',
                label: 'Situação do Registro:',
                optionsType: 'statusContrato'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'nomeCredor',
                label: 'Nome do Credor:'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'nomeDevedor',
                label: 'Nome do Devedor:'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'documentoDevedor',
                label: 'N° do Documento do Devedor:',
                maxLength: 14
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'ufDevedor',
                label: 'UF do Devedor:',
                optionsType: 'uf'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'municipioDevedor',
                label: 'Município do Devedor'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        }
    ]
